import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { CollapsibleListSection } from 'ui-components/components/collapsible-list/collapsible-list-section';
import { CollapsibleListSectionHeader } from 'ui-components/components/collapsible-list/collapsible-list-section-header';
import { CollapsibleListSectionContent } from 'ui-components/components/collapsible-list/collapsible-list-section-content';
import { noop } from 'ui-components/default-props/noop';

import GroupItemsBySelector from './group-items-by-selector';
import { GroupByOrderNumber } from './group-by-order-number';
import GroupByItem from './group-by-item';

import { MessageDescriptorPropType } from '../../../../prop-types/intl';

import { useUserSettingGroupItemsBy } from './hooks';
import { orders } from './constants';
import messages from './messages';
import style from './grouped-order-items.module.less';

const GroupedOrderItems = ({
  open = false,
  onClick = noop,
  sectionHeader = messages.unShippedItems,
  dragHandleProps,
  willInventoryShow = false,
  totalCount = 0,
  openProductDetailModal,
  fulfillmentPlanIds,
}) => {
  const { userSettingGroupItemsBy, setUserSettingGroupItemsBy } = useUserSettingGroupItemsBy();
  const GroupByComponent = userSettingGroupItemsBy === orders ? GroupByOrderNumber : GroupByItem;
  const onSectionHeaderClick = useCallback(
    (e) => {
      const classList = (e.target && e.target.classList) || [];
      const parentClassList = e?.target?.parentElement?.classList || [];
      const targetClasses = [...classList, ...parentClassList];
      if (targetClasses.length && [...new Set(targetClasses)].some((targetClass) => targetClass.indexOf('group-items-by-toggler') !== -1)) {
        return;
      }
      onClick(open);
    },
    [onClick, open],
  );
  return (
    <CollapsibleListSection open={open}>
      <CollapsibleListSectionHeader
        dragHandleProps={dragHandleProps}
        onClick={(e) => onSectionHeaderClick(e)}
        summaryData={totalCount.toString()}
        theme='white'
      >
        <div className={style['section-header-content']}>
          <FormattedMessage {...sectionHeader} />
          <GroupItemsBySelector setUserSettingGroupItemsBy={setUserSettingGroupItemsBy} userSettingGroupItemsBy={userSettingGroupItemsBy} />
        </div>
      </CollapsibleListSectionHeader>
      <CollapsibleListSectionContent>
        <div className={style['grouped-items-wrapper']}>
          {totalCount === 0 && (
            <div className={style['no-items']}>
              <FormattedMessage {...messages.noItems} />
            </div>
          )}
          {totalCount !== 0 && (
            <GroupByComponent
              fulfillmentPlanIds={fulfillmentPlanIds}
              openProductDetailModal={openProductDetailModal}
              willInventoryShow={willInventoryShow}
            />
          )}
        </div>
      </CollapsibleListSectionContent>
    </CollapsibleListSection>
  );
};

GroupedOrderItems.propTypes = {
  open: PropTypes.bool,
  onClick: PropTypes.func,
  totalCount: PropTypes.number,
  sectionHeader: MessageDescriptorPropType,
  dragHandleProps: PropTypes.object,
  willInventoryShow: PropTypes.bool,
  openProductDetailModal: PropTypes.func.isRequired,
  fulfillmentPlanIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default GroupedOrderItems;
